import React from 'react'
import ReactDOM from 'react-dom'
import { WscThemeProvider } from '@wsc_sports/components-library'
import { ThemeProvider } from 'styled-components'
import { theme } from '../common/style/theme'

import App from './App'

ReactDOM.render(
  <WscThemeProvider isPrimaryYellow={true}>
    <ThemeProvider theme={theme}>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
      />
      <App />
    </ThemeProvider>
  </WscThemeProvider>,
  document.getElementById('root'),
)
